
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useMatomo } from '@jonkoops/matomo-tracker-react'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip'

import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'
import {
  Link,
} from "react-router-dom"
import { toast } from 'react-toastify'


import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import '$src/styles/datatables.css'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  PeriodsCtx,
} from '$src/components/periods'
import {
  ReportsCtx,
} from '$src/components/reports'
import {
  SchedulesCtx,
} from '$src/components/schedules'
import AdvancedReportsModal from './AdvancedReportsModal';

/**
 * AdvancedReportShowModal
**/
const AdvancedReportShowModal = (props) => {
  // logg(props, 'AdvancedReportShowModal')

  /* ctx */

  const {
    selectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in AdvancedReportShowModal')

  const {
    advancedReport,
    advancedReportShowModalOpen, setAdvancedReportShowModalOpen,
  } = useContext(ReportsCtx)
  logg(useContext(ReportsCtx), 'ReportsCtx in AdvancedReportShowModal')

  // const {
  //   schedulesModalOpen, setSchedulesModalOpen,
  //   schedulesResults,   setSchedulesResults,
  // } = useContext(SchedulesCtx)
  // logg(useContext(SchedulesCtx), 'SchedulesCtx in AdvancedReportShowModal')

  /* state */

  // const [ banks, setBanks ] = useState([])
  const [ sortedBanks, setSortedBanks ] = useState([])
  const [ sortKey, setSortKey ] = useState('Bank_Name')
  const [ sortDir, setSortDir ] = useState(C.asc)


  /* effects */

  // useEffect(() => {
  //   if (!advancedReport.banks || !Object.keys(advancedReport.banks).length) { return }
  //   const tmp = Object.keys(advancedReport.banks).map((rssd) => ({rssd, ...advancedReport.banks[rssd] }) )
  //   setBanks(tmp)
  // }, [ advancedReport.banks ])


  /* sort */
  useEffect(() => {
    const tmp = [...advancedReport.lineitems]
    tmp.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return sortDir === C.asc ? -1 : 1
      } else {
        return sortDir === C.asc ? 1 : -1
      }
    })
    setSortedBanks(tmp)
  }, [ sortKey, sortDir, advancedReport.lineitems ])

  if (!advancedReport.id) { return }
  return <Modal
    ariaHideApp={false}
    className="AdvancedReportShowModal BaseModal"
    isOpen={advancedReportShowModalOpen}
    onRequestClose={ () => setAdvancedReportShowModalOpen(false) }
    overlayClassName="SchedulesModalOverlay"
  >
    <div className='header'>
      <h5>Multi Fi Report: { selectedResource.name }</h5>
      <div className='close' onClick={() => setAdvancedReportShowModalOpen(false)}>&times;</div>
    </div>
    <div className='modal-body'><div className='modal-bodyC'>

      <table className='bordered dataTable'>
        <thead>
          <tr>

            <td className={`cert dt-orderable-asc dt-orderable-desc ${sortKey === 'Bank_Cert' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
              onClick={() => {
                setSortKey('Bank_Cert')
                if (sortKey === 'Bank_Cert') {
                  setSortDir(sortDir === C.asc ? C.desc : C.asc)
                }
              } }
            >FDIC&nbsp;Cert&nbsp;#<span className='dt-column-order'></span></td>

            <td className={`rssd dt-orderable-asc dt-orderable-desc ${sortKey === 'Bank_RSSD' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
              onClick={() => {
                setSortKey('Bank_RSSD')
                if (sortKey === 'Bank_RSSD') {
                  setSortDir(sortDir === C.asc ? C.desc : C.asc)
                }
              } }
            >RSSD&nbsp;ID&nbsp;#<span className='dt-column-order'></span></td>

            <td style={{ minWidth: '500px' }}
              className={`bank-name dt-orderable-asc dt-orderable-desc ${sortKey === 'Bank_Name' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
              onClick={() => {
                setSortKey('Bank_Name')
                if (sortKey === 'Bank_Name') {
                  setSortDir(sortDir === C.asc ? C.desc : C.asc)
                }
              } }
            >Bank name<span className='dt-column-order'></span></td>

            <td className={`city dt-orderable-asc dt-orderable-desc ${sortKey === 'Bank_City' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
              onClick={() => {
                setSortKey('Bank_City')
                if (sortKey === 'Bank_City') {
                  setSortDir(sortDir === C.asc ? C.desc : C.asc)
                }
              } }
            >City<span className='dt-column-order'></span></td>

            <td className={`state dt-orderable-asc dt-orderable-desc ${sortKey === 'Bank_State' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
              onClick={() => {
                setSortKey('Bank_State')
                if (sortKey === 'Bank_State') {
                  setSortDir(sortDir === C.asc ? C.desc : C.asc)
                }
              } }
            >State<span className='dt-column-order'></span></td>

            { advancedReport.labels.map((label, idx) => <td key={idx}
                className={`state dt-orderable-asc dt-orderable-desc ${sortKey === label ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
                onClick={() => {
                  setSortKey(label)
                  if (sortKey === label) {
                    setSortDir(sortDir === C.asc ? C.desc : C.asc)
                  }
                } }
            ><div dangerouslySetInnerHTML={{ __html: label }} ></div><span className='dt-column-order'></span></td> ) || null }

          </tr>
        </thead>
        <tbody>
          { sortedBanks.map((bank, idx) => <tr key={idx} >

            <td>{ bank.Bank_Cert } </td>
            <td>{ bank.Bank_RSSD } </td>
            <td>{ bank.Bank_Name } </td>
            <td>{ bank.Bank_City } </td>
            <td>{ bank.Bank_State } </td>

            { Object.keys( bank.ubpr_periods ).map((ubpr_friendly, idx) => <td key={idx} >
              { bank.ubpr_periods[ubpr_friendly] }
            </td> )}

          </tr> )}
        </tbody>
      </table>

    </div></div>
  </Modal>
}
export default AdvancedReportShowModal
